/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCookie } from '../utils';
import { AuthService } from '../services';
import { Spinner as SpinnerComponent } from '../components';

export const AuthContext = createContext({
  user: null,
  conversion: 0,
  currentRouter: null,
  isLogged: false,
  isLoading: false,
  login: () => {},
  logout: () => {},
  setConversion: () => {},
});

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [conversion, setConversion] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const maybeHasSession = !!getCookie(process.env.REACT_APP_SESSION_NAME);
  const currentRouterCookie = getCookie(`${process.env.REACT_APP_SESSION_NAME}-rset`);
  const currentRouter = currentRouterCookie ? Number(atob(atob(currentRouterCookie))) : null;

  const logout = () => {
    setUser(null);
    AuthService.logout();
    dispatch({ type: 'SET_USER', payload: null });
    dispatch({ type: 'SET_JWT', payload: null });
  }

  useEffect(() => {
    setIsLoading(true);
    if (maybeHasSession) {
      AuthService.getProfile()
        .then(res => {
          setUser(res?.user?.user);
          dispatch({ type: 'SET_USER', payload: res?.user?.user });
        })
        .catch(error => console.log(error))
        .finally(() => setIsLoading(false));

    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        conversion,
        currentRouter,
        isLoading,
        isLogged: maybeHasSession || !!user,
        login: setUser,
        logout,
        setConversion,
        user,
      }}
    >
      {isLoading ? <Spinner /> : children}
    </AuthContext.Provider>
  )
}

const Spinner = () => (
  <div className="w-screen h-screen flex justify-center items-center">
    <SpinnerComponent />
  </div>
);